import { render } from "./CollapseWrapper.vue?vue&type=template&id=04f2d33b"
import script from "./CollapseWrapper.vue?vue&type=script&lang=js"
export * from "./CollapseWrapper.vue?vue&type=script&lang=js"

import "./CollapseWrapper.vue?vue&type=style&index=0&id=04f2d33b&lang=scss"

import exportComponent from "/builds/chatplace/app-gamification/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__